/* eslint-disable no-else-return */
/* eslint-disable no-plusplus */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
import request from './base/request';
import storage from './base/storage';

const sign_in_email = (form) => request.post('/users/signin', form);
// Enhanced sign_up_email that supports role parameter
const sign_up_email = (form) => {
  // Ensure role is included in the form data
  const formData = {
    ...form,
    role: form.role || 'user' // Default to 'user' if no role specified
  };
  return request.post('/users/signup', formData);
};

// Enhanced sign_up_admin specifically for court registration
const sign_up_admin = (form) => {
  const adminFormData = {
    ...form,
    role: 'admin' // Explicitly set role to admin
  };
  return request.post('/users/signup', adminFormData);
};
const createReservation = (form) => request.post('/bookings', form, true);
const save_transaction = (transactionData) => request.post('/payments/submit', transactionData, true);
const search_courts = (filters = {}) => request.get(`/courts?${new URLSearchParams(filters).toString()}`);
const get_user_profile = () => request.get('/users/profile', true);
const update_user_profile = (data) => request.put('/users/profile', data, true);
const update_password = (data) => request.put('/users/password', data, true);
const get_user_bookings = () => request.get('/bookings/user', true);
const cancel_booking = (bookingId) => request.post(`/bookings/${bookingId}/cancel`, {}, true);
const get_payment_methods = () => request.get('/payments/methods');
const get_payment_status = (transactionId) => request.get(`/payments/${transactionId}`, true);

const check_availability = (courtId, date, timeFrom, timeTo) => {
  const params = { courtId, date, timeFrom, timeTo };
  return request.get(`/bookings/availability?${new URLSearchParams(params).toString()}`);
};

// Email verification methods
const verify_email = (token) => request.get(`/email-verification/verify?token=${token}`);
const resend_verification_email = () => request.post('/email-verification/resend', {}, true);
const send_verification_email = () => request.post('/email-verification/send', {}, true);
const check_verification_status = () => request.get('/email-verification/status', true);

// ADD THESE MISSING CANCELLATION METHODS:
const request_booking_cancellation = (cancellationData) => {
  return request.post('/users/booking/cancel-request', cancellationData, true);
};

const get_user_cancellation_requests = (page = 1, limit = 10) => {
  return request.get(`/users/cancellation-requests?page=${page}&limit=${limit}`, true);
};

const verify_token = () => request.get('/users/verify-token', true);

const _expObject = {
  sign_in_email,
  sign_up_email,
  sign_up_admin,
  createReservation,
  save_transaction,
  search_courts,
  get_user_profile,
  update_user_profile,
  update_password,
  get_user_bookings,
  cancel_booking,
  get_payment_methods,
  get_payment_status,
  check_availability,
  verify_email,
  resend_verification_email,
  send_verification_email,
  check_verification_status,
  // ADD THE NEW METHODS HERE:
  request_booking_cancellation,
  get_user_cancellation_requests,
  verify_token
};

export default _expObject;